
// slider
$(function(){
	if (typeof $.fn.slick !== "function") {
		return;
	}

	$(".featured-collection-slider").slick({
		arrows: true,
		autoplay: false,
		centerMode: false,
		dots: false,
		infinite: true,
		slidesToShow: 5,
		prevArrow: '<img src="//saucony.jp/cdn/shop/t/2/assets/icon-slide-prev.svg?v=178942065112072029951734318545" class="icon-slide icon-slide-prev">',
		nextArrow: '<img src="//saucony.jp/cdn/shop/t/2/assets/icon-slide-next.svg?v=77225803235729408351734318544" class="icon-slide icon-slide-next">',
		responsive: [
			{
				breakpoint: 1080, 
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 768, 
				settings: {
					arrows: false,
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 500,
				settings: {
					arrows: false,
					slidesToShow: 2,
				},
			},
		],
});

$(".category_slider").slick({
    arrows: false,
    autoplay: false,
    centerMode: true,
    centerPadding: "6%",
    dots: false,
    infinite: true,
    slidesToShow: 5,
    responsive: [
        {
            breakpoint: 1080, 
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 500,
            settings: {
                slidesToShow: 2,
            },
        },
    ],
});

$(".blog_slider").slick({
		arrows: false,
		autoplay: false,
		centerMode: true,
		dots: false,
		infinite: true,
		slidesToShow: 3,
		responsive: [
			{
				breakpoint: 1080,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});
});

// accordion
$(function () {
	var targetHash = window.location.hash;

	$(".label_irreg").each(function () {
		$(this).addClass("open");
		$(this).next().slideDown(0);
	});

	if (targetHash) {
		var $targetDiv = $(targetHash);

		if ($targetDiv.length) {
			var $detail = $targetDiv.closest(".detail");
			var $label = $detail.prev(".label");
			var $labelIrreg = $detail.prev().prev(".label_irreg");

			if ($label.length) {
				$label.addClass("open");
				$label.next().slideDown();
			} else if ($labelIrreg.length) {
				$labelIrreg.addClass("open");
				$labelIrreg.next().slideDown();
			}
			$("html, body").animate(
				{
					scrollTop: $targetDiv.offset().top - 120,
				},
				500,
			);
		}
	}

	$(".label").on("click", function () {
		$(this).next().slideToggle();
		$(this).toggleClass("open");
	});

	$(".label_irreg").on("click", function () {
		if ($(this).hasClass("open")) {
			$(this).removeClass("open");
			$(this).next().slideUp();
		} else {
			$(this).addClass("open");
			$(this).next().slideDown();
		}
	});
});




//size chart modal
$(function(){
	$("#openModal").on("click", function () {
		$("#modal").fadeIn();
	});

	$("#modal, #closeModal").on("click", function (e) {
		if (e.target.id === "modal" || e.target.id === "closeModal") {
			$("#modal").fadeOut();
		}
	});

	$(".tab").on("click", function () {
		$(".tab").removeClass("active");
		$(this).addClass("active");

		const target = $(this).data("target");
		$(".tab-pane").removeClass("active");
		$(`#${target}`).addClass("active");
	});
});

function openSizeChartModal() {
	$("#modal").fadeIn();
}

//shop-list sort btn

$(document).ready(function () {
	const regions = {
		"hokkaido-tohoku": ["北海道", "青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県"],
		kanto: ["東京都", "茨城県", "栃木県", "群馬県", "埼玉県", "千葉県", "神奈川県"],
		chubu: ["新潟県", "富山県", "石川県", "福井県", "山梨県", "長野県", "岐阜県", "静岡県", "愛知県"],
		kinki: ["京都府", "大阪府", "三重県", "滋賀県", "兵庫県", "奈良県", "和歌山県"],
		"chugoku-shikoku": ["鳥取県", "島根県", "岡山県", "広島県", "山口県", "徳島県", "香川県", "愛媛県", "高知県"],
		"kyushu-okinawa": ["福岡県", "佐賀県", "長崎県", "大分県", "熊本県", "宮崎県", "鹿児島県", "沖縄県"],
	};

	const $tableRows = $("#store-table tbody tr");

	$(".filter-btn").on("click", function () {
		const region = $(this).data("region");

		$tableRows.each(function () {
			const $row = $(this);
			const addressText = $row.find(".address").text();

			if (region === "all") {
				$row.show();
			} else {
				const isMatch = regions[region].some((prefecture) => addressText.includes(prefecture));
				$row.toggle(isMatch);
			}
		});
	});
});

//shop-list pagenation

$(document).ready(function () {
	const rowsPerPage = 15;
	const $table = $("#store-table");
	const $rows = $table.find("tbody tr");
	const $pagination = $("#pagination");

	let currentPage = 1;
	let filteredRows = $rows;

	function showPage(page) {
		filteredRows.hide();
		filteredRows.slice((page - 1) * rowsPerPage, page * rowsPerPage).show();
		updatePagination(page);
	}

	function updatePagination(page) {
		$pagination.empty();

		const totalPages = Math.ceil(filteredRows.length / rowsPerPage);
		if (totalPages <= 1) {
			$pagination.hide();
			return;
		}

		$pagination.show();

		if (page > 1) {
			$("<span>")
				.addClass("page prev")
				.text("<")
				.on("click", function () {
					showPage(page - 1);
				})
				.appendTo($pagination);
		}

		const startPage = Math.max(1, page - 1);
		const endPage = Math.min(totalPages, page + 1);
		for (let i = startPage; i <= endPage; i++) {
			$("<span>")
				.addClass("page")
				.text(i)
				.toggleClass("active", i === page)
				.on("click", function () {
					showPage(i);
				})
				.appendTo($pagination);
		}

		if (page < totalPages) {
			$("<span>")
				.addClass("page next")
				.text(">")
				.on("click", function () {
					showPage(page + 1);
				})
				.appendTo($pagination);
		}
	}

	function filterRows(region) {
		if (region === "all") {
			filteredRows = $rows;
		} else {
			const regions = {
				"hokkaido-tohoku": ["北海道", "青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県"],
				kanto: ["東京都", "茨城県", "栃木県", "群馬県", "埼玉県", "千葉県", "神奈川県"],
				chubu: ["新潟県", "富山県", "石川県", "福井県", "山梨県", "長野県", "岐阜県", "静岡県", "愛知県"],
				kinki: ["京都府", "大阪府", "三重県", "滋賀県", "兵庫県", "奈良県", "和歌山県"],
				"chugoku-shikoku": ["鳥取県", "島根県", "岡山県", "広島県", "山口県", "徳島県", "香川県", "愛媛県", "高知県"],
				"kyushu-okinawa": ["福岡県", "佐賀県", "長崎県", "大分県", "熊本県", "宮崎県", "鹿児島県", "沖縄県"],
			};

			filteredRows = $rows.filter(function () {
				const addressText = $(this).find(".address").text();
				return regions[region].some((prefecture) => addressText.includes(prefecture));
			});
		}

		currentPage = 1;
		showPage(currentPage);
	}

	$(".filter-btn").on("click", function () {
		const region = $(this).data("region");
		filterRows(region);
	});

	showPage(currentPage);
});


$(function(){

	setHoverItemListColorVariants();

});

function setHoverItemListColorVariants() {

	$(".card__colorVariant").hover(
		function () {
			const imgURL = $(this).find('img')[0].src;
			const main = $(this).parent().parent().parent().find('.card__colorVariantMainImg')[0];
			$(main).fadeOut(300);

			const preview = $(this).parent().parent().parent().find('.card__colorVariantPreviewImg')[0];
			$(preview).hide();
			$(preview).attr('src', imgURL);
			$(preview).fadeIn(300);
		},
		function () {
		}
	);

	$(".card__colorVariants").hover(
		function () {
		},
		function () {
			const main = $(this).parent().parent().find('.card__colorVariantMainImg')[0];
			console.log($(main).attr('src'));
			$(main).fadeIn(300);

			const preview = $(this).parent().parent().find('.card__colorVariantPreviewImg')[0];
			$(preview).attr('src', '');
			$(preview).hide();
		}
	);

}

$(document).ready(function () {
    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault(); 

        var targetId = $(this).attr('href').substring(1); 
        var $target = $('#' + targetId); 

        if ($target.length) {
            var offset = 130; 
            var position = $target.offset().top - offset;

            $('html, body').animate(
                {
                    scrollTop: position 
                },
                500 
            );
        }
    });
});


// ギフトカタログ対応-202607 START
// 変更前: ギフトカタログのクーポンコードを、既存のメモ内容を消さずに「メモ」欄（cart.note）へ追記していた
// $(document).on('change', '#CartDrawer-GiftCouponCode, #Cart-GiftCouponCode', function () {
// 	var code = $(this).val().trim();
//
// 	fetch('/cart.js')
// 		.then(function (res) {
// 			return res.json();
// 		})
// 		.then(function (cart) {
// 			var existingNote = cart.note || '';
// 			// 再入力時に重複しないよう、以前のクーポンコード行を除去してから追記し直す
// 			var cleanedNote = existingNote.replace(/^カタログNo:.*$/m, '').trim();
// 			var couponLine = code ? 'カタログNo: ' + code : '';
// 			var combinedNote = [cleanedNote, couponLine].filter(Boolean).join('\n');
//
// 			return fetch(`${routes.cart_update_url}`, {
// 				method: 'POST',
// 				headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
// 				body: JSON.stringify({ note: combinedNote }),
// 			});
// 		});
// });

// 変更後: ギフトカタログのクーポンコードを、カート属性（attributes）の「カタログNo」に保存する
// あわせて、旧実装がメモ欄（cart.note）に書き込んでいたカタログコード行や、
// 旧属性キー gift_coupon_code が残っている場合は取り除く
$(document).on('change', '#CartDrawer-GiftCouponCode, #Cart-GiftCouponCode', function () {
	var code = $(this).val().trim();

	fetch('/cart.js')
		.then(function (res) {
			return res.json();
		})
		.then(function (cart) {
			var existingNote = cart.note || '';
			var cleanedNote = existingNote.replace(/^(カタログNo|クーポンコード):.*$/gm, '').replace(/\n{2,}/g, '\n').trim();

			return fetch(`${routes.cart_update_url}`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
				body: JSON.stringify({
					attributes: { 'カタログNo': code, gift_coupon_code: '' },
					note: cleanedNote,
				}),
			});
		});
});
// ギフトカタログ対応-202607 END

// 商品テンプレート側のBack in Stockアプリブロックを非表示にし、
// 重複が解消されたため、以下の処理はコメントアウト
// 　
// Back in Stockボタン重複のため
// 購入ボタン側の入荷通知ボタンがある場合のみ、Back in Stockアプリブロック側を非表示
// (function () {
//   if (!document.querySelector('product-form')) return;

//   const styleId = 'js-hide-duplicate-bis-style';
//   if (document.getElementById(styleId)) return;

//   const style = document.createElement('style');
//   style.id = styleId;
//   style.textContent = `
//     body:has(product-form #BIS_trigger) .shopify-app-block:has(#BIS_trigger[data-bis-app-block]) {
//       display: none !important;
//     }
//   `;

//   document.head.appendChild(style);
// })();